/* src/lib/components/Layout/PageHeader.ts */

import { BaseComponent } from "@root/components";
import { Component, Prop } from "vue-property-decorator";
// 請根據您的專案結構調整引用路徑

@Component
export default class PageHeader extends BaseComponent {
    /**
     * 頁面描述文字 (顯示在標題下方)
     */
    @Prop({ type: String, required: false, default: "" })
    description!: string;

    /**
     * 定義公開的 slot 名稱 (保持 BaseComponent 的風格)
     */
    publicSlots = {
        default: "@default", // 預設插槽 (通常不使用，預留)
        label: "@label",     // 自定義標題插槽 (如果不想用 label prop)
        actions: "@actions"  // 右側操作區插槽
    };
}